import Logo from '../Assets/images/regxlogo.svg';
import WhiteLogo from '../Assets/images/regxlogo_white.svg';
import LogoPng from '../Assets/images/regxlogo.png';
import WhiteLogoPng from '../Assets/images/regxlogo_white.png';
import AngleDownIcon from '../Assets/images/icons/angle-down.svg';
import CaretIcon from '../Assets/images/icons/caret.svg';
import DeleteIcon from '../Assets/images/icons/delete.svg';
import FundHouseIcon from '../Assets/images/icons/fund_house.svg';
import FundIcon from '../Assets/images/icons/fund.svg';
import EditIcon from '../Assets/images/icons/edit.svg';
import HamburgerIcon from '../Assets/images/icons/hamburger.svg';
import ReportIcon from '../Assets/images/icons/report.svg';
import UserIcon from '../Assets/images/icons/user.svg';
import MaintenanceImage from '../Assets/images/maintenance.svg';

const images = {
  Logo,
  WhiteLogo,
  LogoPng,
  WhiteLogoPng,
  AngleDownIcon,
  CaretIcon,
  DeleteIcon,
  FundHouseIcon,
  FundIcon,
  EditIcon,
  HamburgerIcon,
  ReportIcon,
  UserIcon,
  MaintenanceImage,
};

export default images;
